// Mock data for Muze Madhuprabha Constructions Pvt. Ltd. website

export const projectsData = [
  {
    id: 1,
    titleImage: "/La-maison-gallary/la-massion-name.png",
    titleImg: "/La-maison-gallary/la-massion-name-black.png",
    title: "PRAJAKTA LA-MAISON",
    location: "Pandey Layout",
    fonts: { title: "Parisienne, cursive", status: "Julee, cursive", tagline: "Merriweather, serif" },
    architecture: "Arjun Kamdi, Arya Vertex",
    vastuConsultant: "Kirti Bhai",
    area: "3 & 4 BHKD - 7 Floor",
    type: "Residential",
    status: "Ongoing",
    image: "/images/MP_01.png",
    tagline: "A Gold Green Certified Premium Ultra Luxurious Building",
    descriptionImage: "/La-maison-gallary/la-massion-name-black.png",
    fullDescription: "Introducing, our 7 level 3 BHKD & 4 BHKD ultra luxurious view apartment with strategic location based on european theme. A peaceful location in the heart of the city where you can enjoy your mornings with blissful greenery.A Perfect Home with Modern Amenities at Nagpur.",
    description: "Introducing ‘PRAJAKTA La-Maison’, our 7 level 3 & 4 BHKD ultra luxurious view apartment with strategic location based on European theme, where every movement feels like parision escape, where every day is a celebration of charm with modern amenities at Nagpur. ",
    // description: "Experience Ultra Luxurious european elegance at strategic location at pandey layout, Nagpur",
    completionDate: "2025-12-31",
    brochureURL: "/images/PRAJAKTA LA MAISON_.pdf",
    locationUrl: "https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3722.1884976569895!2d79.0614009752587!3d21.105049880563453!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjHCsDA2JzE4LjIiTiA3OcKwMDMnNTAuMyJF!5e0!3m2!1sen!2sin!4v1760604126508!5m2!1sen!2sin",
    features: [
      "Grand entrance lobby on ground floor",
      "CCTV Cameras in ground floor lobby are parking area",
      "Password protected ground floor lobby area.",
      "Video Door Phones for individual flats",
      "Safety Doors to all flats",
      "Digital locks for secured home.",
      "2 Allotted car park (1 SUV car park) to Individual flat owners.",
      "French Themed elevation."

    ],
    gallery: [
      "/La-maison-gallary/1.jpg",
      "/La-maison-gallary/2.jpg",
      "/La-maison-gallary/3.jpg",
      "/La-maison-gallary/4.jpg",
      "/La-maison-gallary/5.jpg",
    ],
    videoURL: "/La-maison-gallary/main-video.mp4",
    currentProjectsData: [
      "/images/la_maison1.jpg",
      "/images/la_maison3.jpg",
      "/images/la_maison4.jpg",
      "/La-maison-gallary/la_maison5.jpg",
      "/La-maison-gallary/la_maison6.jpg",
      "/La-maison-gallary/la_maison7.jpg",
      "/La-maison-gallary/la_maison8.jpg",
      "/La-maison-gallary/currentstatus1.jpeg",
      "/La-maison-gallary/currentstatus2.jpeg",
      "/La-maison-gallary/currentstatus3.jpeg",
      "/La-maison-gallary/currentstatus4.jpeg",
      "/La-maison-gallary/currentstatus5.jpeg",
      "/La-maison-gallary/currentstatus6.jpeg",
      "/La-maison-gallary/currentstatus7.jpeg",
      "/La-maison-gallary/currentstatus8.jpeg",
      "/La-maison-gallary/currentstatus9.jpeg",
      "/La-maison-gallary/currentstatus10.jpeg",
      "/La-maison-gallary/currentstatus11.jpeg",
      "/La-maison-gallary/currentstatus12.jpeg",
      "/La-maison-gallary/currentstatus13.jpeg",
      "/La-maison-gallary/currentstatus14.jpeg",
      "/La-maison-gallary/la_maison_9.jpeg",
      "/La-maison-gallary/la_maison_10.jpeg",
      "/La-maison-gallary/la_maison_11.jpeg",
      "/La-maison-gallary/la_maison_12.jpeg",
      "/La-maison-gallary/la_maison_13.jpeg",
      "/La-maison-gallary/la_maison_14.jpeg",
      "/La-maison-gallary/la_maison_15.jpeg",
      "/La-maison-gallary/la_maison_16.jpeg",
      "/La-maison-gallary/la_maison_17.jpeg",
      "/La-maison-gallary/la_maison_18.jpeg",
    ]
  },
  {
    id: 2,
    titleImage: "/prajkata-park-name-leaf.png",
    titleImg: "/prajkta-park-removebg-preview.png",
    title: "PRAJAKTA PARK",
    location: "Abhyankar nagar, Nagpur",
    fonts: { title: "Pinyon Script, cursive", status: "Dancing Script, cursive", tagline: "Calibri" },
    architecture: "Arya Vertex",
    // vastuConsultant: " ",
    area: "3BHKD - 5 Floor",
    type: "Residential",
    status: "Ongoing",
    image: "/images/MP_02.png",
    tagline: "Prajakta Park – A perfect harmony of nature, comfort, and modern living..",
    descriptionImage: "/prajkta-park-removebg-preview.png",
    fullDescription: " – Park facing apartments thoughtfully designed residential project that blends nature with modern living. Prajakta Park offers spacious homes surrounded by greenery, ensuring peace and comfort in every corner. With premium amenities, excellent connectivity, and a vibrant community, it is the perfect place to create memories and celebrate life every day.",
    description: " – Park facing apartments thoughtfully designed residential project that blends nature with modern living. Prajakta Park offers spacious homes surrounded by greenery, ensuring peace and comfort in every corner. With premium amenities, excellent connectivity, and a vibrant community, it is the perfect place to create memories and celebrate life every day.",
    completionDate: "2025-12-31",
    brochureURL: "/images/Prajakta-Park-E-Brochure-New-1_compressed (1)(final).pdf",
    features: [
      "Lift with inverter Back Up.",
      "Allotted car park to individual flat owners.",
      "Automatic level water controller to give uninterrupted water supply.",
      "Branded modular switches.",
      "Elegant elevation.",
      "AC points in all the three bed rooms.",
      "100% Vastu compliance.",
      "CCTV Cameras.",
      "Video Door Phones for individual flats.",
      "Intercom Connectivity.",

    ],
    gallery: [
      "/images/prajkta-park-image.png",
      "/images/prajkta-park-image1.png",
      "/images/prajkta-park-image2.png",
      "/images/Prajakta_ParkGallery1.png",
      "/images/Prajakta_ParkGallery2.png",
      "/images/Prajakta_ParkGallery3.png",
      "/images/Prajakta_ParkGallery4.png",

    ],
    currentProjectsData: [
      "/Current_Prajkata_1.jpg",
      "/Current_Prajkata_2.jpg",
      "/Current_Prajkata_3.jpg",
      "/Current_prajkata_4.jpg",
      "/prajktapark/currentstatus1.jpeg",
      "/prajktapark/currentstatus2.jpeg",
      "/prajktapark/currentstatus3.jpeg",
      "/prajktapark/currentstatus4.jpeg",
      "/prajktapark/currentstatus4.jpeg",
      "/prajktapark/currentstatus5.jpeg",
      "/prajktapark/currentstatus6.jpeg",
      "/prajktapark/currentstatus7.jpeg",
      "/prajktapark/currentstatus8.jpeg",
      "/prajktapark/currentstatus9.jpeg",
    ]


  },
  {
    id: 3,
    title: "PRAJAKTA CLASSIC",
    location: "Abhyankar Nagar, Nagpur",
    fonts: { title: "Montserrat, sans-serif", status: "Julee, cursive", tagline: "Open Sans, sans-serif" },
    area: "3BHK",
    type: "Residential",
    status: "Completed",
    image: "/images/park_img_page-0001.jpg ",
    tagline: "Classical theme based Spacious flats with garden and parking facility.",
    fullDescription: "An exclusive collection of 5 meticulously designed hand-sculpted 3 BHKD apartments.This based on classical theme with modern conveniences across 1800 sq ft of thoughtfully designed space.",
    description: "An exclusive collection of 5 meticulously designed hand-sculpted 3 BHKD apartments.This based on classical theme with modern conveniences across 1800 sq ft of thoughtfully designed space.",
    completionDate: "2024-12-31",
    // brochureURL: "/images/Prajakta Classic E-Brochure.pdf",
    // features: [
    //   "Lift with inverter Back Up",
    //   "Allotted car park to individual flat owners.",
    //   "Automatic level water controller to give uninterrupted water supply.",
    //   "Branded modular switches.",
    //   "Elegant elevation",
    //   "AC points in all the three bed rooms",
    //   "100% Vastu compliance.",
    //   "Video Door Phones for individual flats."
    // ],
    gallery: [
      "/images/prajakta classic51.jpg",
      "/images/prajakta classic52.jpg",
      "/images/prajakta classic53.jpg",
      "/images/prajakta classic54.jpg"
    ],
    //  Add your video here:
    videoURL: "/prajakta_classic_video/prajkata-classic_video.mp4"
  },
  {
    id: 4,
    title: 'Prajakta Green Serenity',
    location: 'Madhav Nagar Near Mate Square,Nagpur',
    fonts: { title: "Cinzel, serif", status: "Satisfy, cursive", tagline: "Merriweather, serif" },
    architecture: "Arya Vertex",
    area: "3BHK",
    type: "Residential",
    status: "Completed",
    image: "/images/cam_no_32_FINAL_Right_Night_copy[1].jpg",
    tagline: 'An expansive retail complex designed with modern entertainment zones and hassle-free parking solutions.',
    fullDescription: `Luxurious 3 BHKD flats, where comfort meets elegance. Designed with thoughtful planning and premium amenities.`,
    description: "Luxurious 3 BHKD flats, where comfort meets elegance. Designed with thoughtful planning and premium amenities.",
    completionDate: "2023-12-31",
    // brochureURL: "/images/Green Serenity E-brochure..pdf",
    // features: [
    //   "Lift with inverter Back Up.",
    //   "Allotted car park to individual flat owners.",
    //   "Automatic level water controller to give uninterrupted water supply.",
    //   "Branded modular switches.",
    //   "Elegant elevation.",
    //   "AC points in all the three bed rooms.",
    //   "100% Vastu compliance.",
    //   "CCTV Cameras",
    //   "Video Door Phones for individual flats.",
    //   "Intercom Connectivity.",
    // ],
    gallery: [
      "/images/Green Serenity E-brochure1_page-0001.jpg",
      "/images/Green Serenity E-brochure2_page-0001.jpg",
      "/images/Green Serenity E-brochure4_page-0001.jpg",
      "/greenSerenity/1.jpeg",
      "/greenSerenity/4.jpeg",
      "/greenSerenity/2.jpeg",
      "/greenSerenity/3.jpeg",
      "/greenSerenity/5.jpeg",

    ],
    videoURL: "/greenSerenity/greenserenity.mp4"
  },

  {
    id: 5,
    title: 'Prajakta Greenfinity',
    location: 'Wanjari Nagar, Near Medical Square, Nagpur',
    fonts: { title: "Poppins", tagline: "Roboto" },
    architecture: "Arya Vertex",
    area: "1423 Sq.Ft - 1552 Sq.Ft 3BHK - 7 Floor",
    type: "Residential",
    status: "Completed",
    image: '/images/Green-finity-image.png',
    tagline: 'Enjoy The Blissful Life in the Harmony of Mother Nature.',
    fullDescription: "Introducing ‘PRAJAKTA GREENFINITY’, our 7 level 3 BHKD luxurious greenery view apartment located in the lap of nature.",

    description: "Introducing ‘PRAJAKTA GREENFINITY’, our 7 level 3 BHKD luxurious greenery view apartment located in the lap of nature. ",
    completionDate: "2023-12-31",
    // brochureURL: "/images/Prajakta_Greenfinity_E-brochure .pdf",
    // features: [
    //   "Lift with Back Up.",
    //   "Allotted car park to individual flat owners.",
    //   "Automatic level water controller to give uninterrupted water supply.",
    //   "Branded modular switches.",
    //   "Elegant elevation.",
    //   "AC points in all the three bed rooms.",
    //   " 100% Vastu compliance.",
    //   "CCTV Cameras.",
    //   "Video Door Phones for individual flats.",
    //   "Guard cabin on ground floor."
    // ],
    gallery: [
      // "/images/prajakta-greeninfinity50.jpg",
      // "/images/prajakta greeninfinity60.jpg",
      // "/images/prajakta greeninfinity57.jpg",
      // "/images/prajakta greeninfinity58.jpg",
      // "/images/prajakta greeninfinity59.jpg",
      // "/prajakta_greenfinity/1.jpeg",

      // "/prajakta_greenfinity/2.jpeg",
      // "/prajakta_greenfinity/3.jpeg",
      // "/prajakta_greenfinity/4.jpeg",
      // "/prajakta_greenfinity/5.jpeg",
      // "/prajakta_greenfinity/6.jpeg",
      // "/prajakta_greenfinity/7.jpeg",

      // "/prajakta_greenfinity/8.jpeg",
      // "/prajakta_greenfinity/9.jpeg",

      // "/prajakta_greenfinity/10.jpeg",
      // "/prajakta_greenfinity/11.jpeg",
      // "/prajakta_greenfinity/12.jpeg",
      // "/prajakta_greenfinity/13.jpeg",
      // "/prajakta_greenfinity/14.jpeg",
      "/greenfinity/greenfinity1.jpg",
      "/greenfinity/greenfinity2.jpg",
      "/greenfinity/greenfinity3.jpg",
      "/greenfinity/greenfinity4.jpg",
      "/greenfinity/greenfinity5.jpg",
      "/greenfinity/greenfinity5.jpg",
      "/greenfinity/greenfinity6.jpg",
      "/greenfinity/greenfinity7.jpg",
      "/greenfinity/greenfinity8.jpg",
      "/greenfinity/greenfinity9.jpg",
      "/greenfinity/greenfinity10.jpg",
    ],

    videoURL: "/prajakta_greenfinity/greenfinity.mp4"
  },

  {
    id: 6,
    title: 'Prajakta Ikebana',
    location: "Bajaj Nagar, Nagpur",
    fonts: { title: "Poppins", tagline: "Roboto" },
    area: "3BHK",
    type: "Residential",
    status: "Completed",
    image: '/3.jpeg',
    tagline: "Spacious Premium Apartments",
    fullDescription: "This elegant apartment home combines traditional charm with commercial cum residential spacious apartments.",
    description: "This elegant apartment home combines traditional charm with commercial cum residential spacious apartments.",
    completionDate: "2020-12-31",
    // features: [
    //   "Duplex design with 3 bedrooms",
    //   "Open-plan ground floor",
    //   "Private garden and terrace",
    //   "Modern kitchen with breakfast counter",
    //   "Master suite with walk-in closet",
    //   "Covered parking for 2 cars",
    //   "Premium wood flooring",
    //   "Energy-efficient lighting"
    // ],
    gallery: [
      "/ikebana/ikebana1.jpg",
      "/ikebana/ikebana2.jpg",
      "/ikebana/ikebana3.jpg",
      "/ikebana/ikebana4.jpg",
      "/ikebana/ikebana5.jpg",
      "/ikebana/ikebana6.jpg",
      "/ikebana/ikebana7.jpg",
      "/ikebana/ikebana8.jpg",
      "/ikebana/ikebana9.jpg",
      "/ikebana/ikebana10.jpg",
      "/ikebana/ikebana11.jpg",
      "/ikebana/ikebana12.jpg",
      "/ikebana/ikebana13.jpg",
      "/images/Prajakta-Prabhakamal-images2.jpg",
      "/images/Prajakta-Prabhakamal-images1.jpg",
      // "/images/Prajakta-Prabhakamal-images4.jpg",
      "/images/Prajakta-Prabhakamal-images5.jpg",
      // "/images/Prajakta-Prabhakamal-images6.jpg",
      // "/images/Prajakta-Prabhakamal-images7.jpg",
    ],
    videoURL: "/prajaktaIkebana/prajakta_Ikebana.mp4"
  },
  {
    id: 7,
    title: 'Keshav Enclave Nandanwan',
    location: ' Nandanwan, Nagpur',
    fonts: { title: "Poppins", tagline: "Roboto" },
    area: "3BHK",
    type: "Residential",
    status: "Completed",
    // image: '/images/WhatsApp-Image-2021-09-20-at-4.55.37-PM.jpeg',
    // image: '/images/keshav-enclave-nandanwan.jpg',

    tagline: 'Residential facility with advanced infrastructure and safety systems.',
    fullDescription: "Residential cum commercial Project located on Nandanvan Main Road. This was the first Project by Ashish Constructions completed in the year 2007.",
    description: "Residential cum commercial Project located on Nandanvan Main Road. This was the first Project by Ashish Constructions completed in the year 2007.",
    // completionDate: "2025-12-31",
    // features: [
    //   "Duplex design with 3 bedrooms",
    //   "Open-plan ground floor",
    //   "Private garden and terrace",
    //   "Modern kitchen with breakfast counter",
    //   "Master suite with walk-in closet",
    //   "Covered parking for 2 cars",
    //   "Premium wood flooring",
    //   "Energy-efficient lighting"
    // ],
    gallery: [

    ]
  },
  {
    id: 8,
    title: 'Prajakta cross Winds',
    location: "Hingna Road, Nagpur",
    fonts: { title: "Poppins", tagline: "Roboto" },
    area: "2-3BHK",
    type: "Residential",
    status: "Completed",
    // image: '/images/PRAJAKTA-CROSSWIND-HINGANA-ROAD.jpg',
    tagline: "Spacious duplex with garden and parking facility.",
    description: "Truly windy project located on the bank of Ambazari Back water. A mix of 2 BHKD and 3 BHKD Flats completed in the year 2013.",
    // completionDate: "2025-12-31",
    fullDescription: "This elegant duplex home combines traditional charm with modern conveniences across 2800 sq ft of thoughtfully designed space. The ground floor features an open living area, modern kitchen, and guest bedroom, while the upper level houses the master suite and additional bedrooms. The property includes a private garden, covered parking, and premium finishes throughout.",
    // features: [
    //   "Duplex design with 3 bedrooms",
    //   "Open-plan ground floor",
    //   "Private garden and terrace",
    //   "Modern kitchen with breakfast counter",
    //   "Master suite with walk-in closet",
    //   "Covered parking for 2 cars",
    //   "Premium wood flooring",
    //   "Energy-efficient lighting"
    // ],
    gallery: [

    ]
  },
  {
    id: 22,
    title: 'Subhashish  Square',
    location: "Shraddhanandpeth, Nagpur",
    fonts: { title: "Poppins", tagline: "Roboto" },
    area: "3BHK",
    type: "Commercial & Residential",
    status: "Completed",
    image: '/shraddhanandpeth square/1.jpeg',
    tagline: "A Luxurious Commercial & Residential Project located in Shraddhanandpeth. This project is a mix of shops and offices, Homes.",
    fullDescription: "The project is a blend of commercial spaces, including shops and offices, designed to meet the needs of modern businesses. With its prime location in Shraddhanandpeth, it offers excellent visibility and accessibility. The architecture is contemporary, featuring spacious layouts, ample parking, and state-of-the-art facilities to support a thriving business environment.",
    description: "A Luxurious Commercial & Residential Project located in Shraddhanandpeth. This project is a mix of shops and offices.",
    features: [
      "Prime location in Shraddhanandpeth",
      "Contemporary architecture",
      "Spacious layouts for shops and offices",
      "Ample parking facilities",
      "State-of-the-art amenities for businesses",
    ],
    gallery: [
      "/shraddhanandpeth square/1.jpeg",
      "/shraddhanandpeth square/2.jpeg",
      "/shraddhanandpeth square/3.jpeg",
      "/shraddhanandpeth square/4.jpeg",
      "/shraddhanandpeth square/5.jpeg",

    ]
  },

  {
    id: 9,
    title: 'Prajakta Orchid',
    location: "Pandey Layout, Nagpur",
    fonts: { title: "Poppins", tagline: "Roboto" },
    area: "3BHK",
    type: "Residential",
    status: "Completed",
    image: '/images/PRAJAKTA-ORCHID-PANDEY-LAYOUT.jpg',
    tagline: "Spacious duplex with garden and parking facility.",
    fullDescription: "This elegant duplex home combines traditional charm with modern conveniences across 2800 sq ft of thoughtfully designed space. The ground floor features an open living area, modern kitchen, and guest bedroom, while the upper level houses the master suite and additional bedrooms. The property includes a private garden, covered parking, and premium finishes throughout.",
    description: "Mix of 2 BHKD and 3 BHKD Flats in Pandey Layout completed in the year 2010",
    // completionDate: "2025-12-31",
    // features: [
    //   "Duplex design with 3 bedrooms",
    //   "Open-plan ground floor",
    //   "Private garden and terrace",
    //   "Modern kitchen with breakfast counter",
    //   "Master suite with walk-in closet",
    //   "Covered parking for 2 cars",
    //   "Premium wood flooring",
    //   "Energy-efficient lighting"
    // ],
    gallery: [
      "/images/Prajakta-orchid-images.jpg",
      "/images/Prajakta-Orchid-images2.jpg",

      "/images/Prajakta-orchid-images4.jpg",
      "/images/Prajakta-Orchid-images1.jpg",
      "/images/Prajakta-Orchid-images6.jpg",

    ]
  },


  // {
  //   id: 10,
  //   title: 'Keshav Enclave',
  //   location: "Nandanwan, Nagpur",
  //   fonts: { title: "Poppins", tagline: "Roboto" },
  //   area: "3BHK",
  //   type: "Residential",
  //   status: "Completed",
  //   image: '/images/keshav-enclave-nandanwan.jpg',
  //   tagline: "Spacious duplex with garden and parking facility.",
  //   fullDescription: "This elegant duplex home combines traditional charm with modern conveniences across 2800 sq ft of thoughtfully designed space. The ground floor features an open living area, modern kitchen, and guest bedroom, while the upper level houses the master suite and additional bedrooms. The property includes a private garden, covered parking, and premium finishes throughout.",
  //   description: "Madhuprabha Constructions Pvt. Ltd. a trusted brand since 20 year in real estate adding one more brighter light to the chandelier. ”Keshav Enclave” A Home with a modern touch where every moment is an occasion to celebrate. ",

  //   gallery: [

  //   ]
  // },


  {
    id: 11,
    title: 'Honey Archana Complex',
    location: "Unthkhana Road, Nagpur",
    fonts: { title: "Poppins", tagline: "Roboto" },
    area: "3BHK",
    type: "Residential",
    status: "Completed",
    // image: 'https://ashishconstruction.in/wp-content/uploads/2021/09/uttam-apartment-nandanwan.jpg',
    tagline: "Spacious duplex with garden and parking facility.",
    fullDescription: "This elegant duplex home combines traditional charm with modern conveniences across 2800 sq ft of thoughtfully designed space. The ground floor features an open living area, modern kitchen, and guest bedroom, while the upper level houses the master suite and additional bedrooms. The property includes a private garden, covered parking, and premium finishes throughout.",
    description: "Biggest Project on Unthkhana Road having approximately 60 Flats and 80 Shops.",
    // completionDate: "2025-12-31",
    // features: [
    //   "Duplex design with 3 bedrooms",
    //   "Open-plan ground floor",
    //   "Private garden and terrace",
    //   "Modern kitchen with breakfast counter",
    //   "Master suite with walk-in closet",
    //   "Covered parking for 2 cars",
    //   "Premium wood flooring",
    //   "Energy-efficient lighting"
    // ],
    gallery: [

    ]
  },

  {
    id: 12,
    title: 'Ashish Annex',
    location: "Laxmi Nagar, Nagpur",
    fonts: { title: "Poppins", tagline: "Roboto" },
    area: "3BHK",
    type: "Residential",
    status: "Completed",
    image: 'https://ashishconstruction.in/wp-content/uploads/2021/09/IMG_20210930_134037-1-min-scaled.jpg',
    tagline: "Spacious duplex with garden and parking facility.",
    fullDescription: "This elegant duplex home combines traditional charm with modern conveniences across 2800 sq ft of thoughtfully designed space. The ground floor features an open living area, modern kitchen, and guest bedroom, while the upper level houses the master suite and additional bedrooms. The property includes a private garden, covered parking, and premium finishes throughout.",
    description: "Fully commercial project located on the busiest west high court road, Laxmi Nagar, was completed in the year 2008",
    // completionDate: "2025-12-31",
    // features: [
    //   "Duplex design with 3 bedrooms",
    //   "Open-plan ground floor",
    //   "Private garden and terrace",
    //   "Modern kitchen with breakfast counter",
    //   "Master suite with walk-in closet",
    //   "Covered parking for 2 cars",
    //   "Premium wood flooring",
    //   "Energy-efficient lighting"
    // ],
    gallery: [

    ]
  },



  {
    id: 13,
    title: 'Sai Bhushan',
    location: "Swajata Layout, Swalambai Nagar, Nagpur",
    fonts: { title: "Poppins", tagline: "Roboto" },
    area: "3BHK",
    type: "Residential",
    status: "Completed",
    image: 'https://ashishconstruction.in/wp-content/uploads/2021/09/SAI-BHUSAN-SWALAMBI-NAGAR.jpg',
    tagline: "Spacious duplex with garden and parking facility.",
    fullDescription: "This elegant duplex home combines traditional charm with modern conveniences across 2800 sq ft of thoughtfully designed space. The ground floor features an open living area, modern kitchen, and guest bedroom, while the upper level houses the master suite and additional bedrooms. The property includes a private garden, covered parking, and premium finishes throughout.",
    description: "A Project of 2 BHKD Flats in Sujata layout in Trimurti Nagar Completed in the year 2011",
    // completionDate: "2025-12-31",
    // features: [
    //   "Duplex design with 3 bedrooms",
    //   "Open-plan ground floor",
    //   "Private garden and terrace",
    //   "Modern kitchen with breakfast counter",
    //   "Master suite with walk-in closet",
    //   "Covered parking for 2 cars",
    //   "Premium wood flooring",
    //   "Energy-efficient lighting"
    // ],
    gallery: [

    ]
  },

  {
    id: 13,
    title: 'DMA Harmony',
    location: "Pune",
    fonts: { title: "Poppins", tagline: "Roboto" },
    area: "3BHK",
    type: "Residential",
    status: "Completed",
    // image: 'https://ashishconstruction.in/wp-content/uploads/2021/09/DMA-HORMONEY-PUNE.jpg',
    tagline: "Spacious duplex with garden and parking facility.",
    fullDescription: "This elegant duplex home combines traditional charm with modern conveniences across 2800 sq ft of thoughtfully designed space. The ground floor features an open living area, modern kitchen, and guest bedroom, while the upper level houses the master suite and additional bedrooms. The property includes a private garden, covered parking, and premium finishes throughout.",
    description: "Our only project in Pune located at balewadi. Having combination of 2 BHKD and 3 BHKD Flats completed in the year 2011",
    // completionDate: "2025-12-31",
    // features: [
    //   "Duplex design with 3 bedrooms",
    //   "Open-plan ground floor",
    //   "Private garden and terrace",
    //   "Modern kitchen with breakfast counter",
    //   "Master suite with walk-in closet",
    //   "Covered parking for 2 cars",
    //   "Premium wood flooring",
    //   "Energy-efficient lighting"
    // ],
    gallery: [

    ]
  },
  {
    id: 14,
    title: 'Sai Vatika Layout',
    location: "Issasani, Nagpur",
    fonts: { title: "Poppins", tagline: "Roboto" },
    area: "3BHK",
    type: "Residential",
    status: "Completed",
    image: '/images/sai_vatika.jpg',
    tagline: "Spacious duplex with garden and parking facility.",
    fullDescription: "This elegant duplex home combines traditional charm with modern conveniences across 2800 sq ft of thoughtfully designed space. The ground floor features an open living area, modern kitchen, and guest bedroom, while the upper level houses the master suite and additional bedrooms. The property includes a private garden, covered parking, and premium finishes throughout.",
    description: "Layout of 6 acres was developed in the year 2009 with Temple, Garden , an entrance gate located in Issasani. Very close proximity to colleges and Hospitals.",
    // completionDate: "2025-12-31",
    // features: [
    //   "Duplex design with 3 bedrooms",
    //   "Open-plan ground floor",
    //   "Private garden and terrace",
    //   "Modern kitchen with breakfast counter",
    //   "Master suite with walk-in closet",
    //   "Covered parking for 2 cars",
    //   "Premium wood flooring",
    //   "Energy-efficient lighting"
    // ],
    gallery: [
      "/images/Sai-Vatika-Layout-images1.jpg",
      "/images/Sai-Vatika-Layout-images2.jpg",
      "/images/Sai-Vatika-Layout-images3.jpg",
      "/images/Sai-Vatika-Layout-images4.jpg",
    ]
  },
  {
    id: 15,
    title: 'Prajakta Gardens',
    location: "Gopal Nagar, Nagpur",
    fonts: { title: "Poppins", tagline: "Roboto" },
    area: "3BHK",
    type: "Residential",
    status: "Completed",
    // image: '/images/prajkta-garden.jpg',
    tagline: "Spacious duplex with garden and parking facility.",
    fullDescription: "This elegant duplex home combines traditional charm with modern conveniences across 2800 sq ft of thoughtfully designed space. The ground floor features an open living area, modern kitchen, and guest bedroom, while the upper level houses the master suite and additional bedrooms. The property includes a private garden, covered parking, and premium finishes throughout.",
    description: "An affordable 2 BHKD Flats Project located in Gopal Nagar was completed in the year 2010",
    // completionDate: "2025-12-31",
    // features: [
    //   "Duplex design with 3 bedrooms",
    //   "Open-plan ground floor",
    //   "Private garden and terrace",
    //   "Modern kitchen with breakfast counter",
    //   "Master suite with walk-in closet",
    //   "Covered parking for 2 cars",
    //   "Premium wood flooring",
    //   "Energy-efficient lighting"
    // ],
    gallery: [

    ]
  },
  {
    id: 16,
    title: 'Prajakta Royale',
    location: "Abhayankar Nagar, Nagpur",
    fonts: { title: "Poppins", tagline: "Roboto" },
    area: "3BHK",
    type: "Residential",
    status: "Completed",
    // image: '/images/WhatsApp-Image-2021-09-20-at-4.55.37-PM.jpeg',
    tagline: "An award winning Project of 3 BHKD flats in luxurious category in the year 2012.",
    fullDescription: "An award winning Project of 3 BHKD flats in luxurious category in the year 2012.",
    description: "An award winning Project of 3 BHKD flats in luxurious category in the year 2012.",
    // completionDate: "2025-12-31",
    // features: [
    //   "Duplex design with 3 bedrooms",
    //   "Open-plan ground floor",
    //   "Private garden and terrace",
    //   "Modern kitchen with breakfast counter",
    //   "Master suite with walk-in closet",
    //   "Covered parking for 2 cars",
    //   "Premium wood flooring",
    //   "Energy-efficient lighting"
    // ],
    gallery: [

    ]
  },
  {
    id: 17,
    title: 'Uttam Apartment',
    location: "Nandanwan, Nagpur",
    fonts: { title: "Poppins", tagline: "Roboto" },
    area: "3BHK",
    type: "Residential",
    status: "Completed",
    // image: '/images/uttam-apartment-nandanwan.jpg',
    tagline: "Residential cum commercial project on Nandanvan main road completed in the year 2007",
    fullDescription: "Residential cum commercial project on Nandanvan main road completed in the year 2007",
    description: "Residential cum commercial project on Nandanvan main road completed in the year 2007",
    gallery: [

    ]
  },
  {
    id: 18,
    title: 'Prajakta Prabhakamal',
    location: "Shankar Nagar, Nagpur",
    fonts: { title: "Poppins", tagline: "Roboto" },
    area: "3BHK",
    type: "Residential",
    status: "Completed",
    // image: '/images/uttam-apartment-nandanwan.jpg',
    tagline: "Truly luxurious 3 BHKD Flats located in the heart of the city Shankar Nagar completed in the year 2016",
    fullDescription: "Truly luxurious 3 BHKD Flats located in the heart of the city Shankar Nagar completed in the year 2016",
    description: "Truly luxurious 3 BHKD Flats located in the heart of the city Shankar Nagar completed in the year 2016",
    gallery: [

    ]
  },
  {
    id: 19,
    title: 'Prajakta Marigold',
    location: "Bajaj Nagar, Nagpur",
    fonts: { title: "Poppins", tagline: "Roboto" },
    area: "3BHK",
    type: "Residential",
    status: "Completed",
    // image: '/images/uttam-apartment-nandanwan.jpg',
    tagline: "Luxurious 3 BHKD Premium Apartments",
    fullDescription: "Luxurious 3 BHKD Premium Apartments",
    description: "Luxurious 3 BHKD Premium Apartments",
    gallery: [

    ]
  },
  {
    id: 20,
    title: 'Prajakta Pinnacle',
    location: "Telecom Nagar, Nagpur",
    fonts: { title: "Poppins", tagline: "Roboto" },
    area: "3BHK",
    type: "Residential",
    status: "Completed",
    // image: '/images/uttam-apartment-nandanwan.jpg',
    tagline: "Luxurious 3 BHKD Premium Apartments",
    fullDescription: "Luxurious 3 BHKD Premium Apartments",
    description: "Luxurious 3 BHKD Premium Apartments",
    gallery: [

    ]
  },
  {
    id: 21,
    title: 'Shubhashish Square',
    location: "South Ambazari Road, Nagpur",
    fonts: { title: "Poppins", tagline: "Roboto" },
    area: "3BHK",
    type: "Residential",
    status: "Completed",
    // image: '/images/uttam-apartment-nandanwan.jpg',
    tagline: "Full commercial, Perfect place for professionals",
    fullDescription: "Full commercial, Perfect place for professionals",
    description: "Full commercial, Perfect place for professionals",
    gallery: [

    ]
  },


];

export const currentProjectsData = [
  {
    id: 15,
    title: "3BHK Luxurious Prajakta Park",
    location: "Abhyankar Nagar, Nagpur",
    type: "Residential",
    status: "In Progress",

    image: "/images/HDPHOTO1.png",
    tagline: "A 5 level 3 BHKD luxurious park view apartment located in the lap of nature. A peaceful location in the heart of the city where you can enjoy your mornings with blissful greenery. A Perfect Home with Modern Amenities at Abhyankar Nagar, Nagpur.",
    fullDescription: "Currently under construction, this prestigious 5-floor luxury apartment complex will feature 40 premium units with breathtaking city views. The project includes a sky lounge, infinity pool, fitness center, and landscaped gardens. Each apartment is designed with premium finishes and smart home features.",
    features: [
      "40 luxury apartments (2-4 BHK)",
      "5-floor high-rise building",
      "Sky lounge with city views",
      "Infinity pool and deck",
      "State-of-the-art fitness center",
      "Landscaped podium gardens",
      "5-level basement parking",
      "24/7 concierge service"
    ],
    gallery: [
      "https://ashishconstruction.in/wp-content/uploads/2025/07/IMG-20250703-WA0008.jpg",
      "https://ashishconstruction.in/wp-content/uploads/2025/07/IMG-20250703-WA0008.jpg",
    ]
  },
  {
    id: 16,
    title: "3BHK Luxurious Prajakta La-Masion",
    location: "Pandey Layout, Nagpur",
    type: "Residential",
    status: "In Progress",
    image: "https://madhuprabhaconstructions.in/images/secondProject.jpg",
    tagline: "A 7 level 3 BHKD luxurious view apartment located in the lap of nature. A peaceful location in the heart of the city where you can enjoy your mornings with blissful greenery. A Perfect Home with Modern Amenities at Nagpur.",
    features: [
      "6 individual eco-villas",
      "4 bedrooms with valley views",
      "Solar power generation",
      "Rainwater harvesting systems",
      "Natural stone and wood finishes",
      "Private infinity pools",
      "Organic kitchen gardens",
      "Electric vehicle charging"
    ],
    gallery: [
      "https://ashishconstruction.in/wp-content/uploads/2025/07/IMG-20250703-WA0008.jpg",
      "https://ashishconstruction.in/wp-content/uploads/2025/07/IMG-20250703-WA0008.jpg",
    ]
  },

];

export const galleryImages = [
  {
    id: 1,
    url: "https://madhuprabhaconstructions.in/images/madhuprabha.png",
    title: "Madhu Prabha Construction",
    category: "image"
  },
  {
    id: 2,
    url: "https://madhuprabhaconstructions.in/images/certification.jpeg",
    title: "Certification",
    category: "image"
  },

  {
    id: 4,
    url: "https://madhuprabhaconstructions.in/images/carazol5.JPG",
    title: "Project View",
    category: "image"
  },
  {
    id: 5,
    url: "https://madhuprabhaconstructions.in/images/all%20member%20.JPG",
    title: "Team Members",
    category: "image"
  },
  {
    id: 7,
    url: "https://madhuprabhaconstructions.in/images/Prajktaproject.JPG",
    title: "Prajakta Project",
    category: "image"
  },
  {
    id: 8,
    url: "https://madhuprabhaconstructions.in/images/carazol6.JPG",
    title: "Project View",
    category: "image"
  },
  {
    id: 9,
    url: "https://madhuprabhaconstructions.in/images/prajktaclassic.png",
    title: "Prajakta Classic",
    category: "image"
  },
  {
    id: 10,
    url: "https://madhuprabhaconstructions.in/images/PRAJAKTA-PINNACLE-TELECOM-NAGAR.jpg",
    title: "Prajakta Pinnacle",
    category: "image"
  },
  {
    id: 11,
    url: "https://madhuprabhaconstructions.in/images/portfolio3.png",
    title: "Prajakta Green Serenity",
    category: "image"
  },
  {
    id: 12,
    url: "https://madhuprabhaconstructions.in/images/portfolio4.jpeg",
    title: "Greenfinity View Apartment",
    category: "image"
  }, {
    id: 13,
    url: "/images/gallery_10.jpg",
    title: "Greenfinity View Apartment",
    category: "image"
  }, {
    id: 14,
    url: "/images/gallery_11.jpg",
    title: "Greenfinity View Apartment",
    category: "image"
  }, {
    id: 15,
    url: "/images/gallery_12.jpg",
    title: "Greenfinity View Apartment",
    category: "image"
  }, {
    id: 16,
    url: "/images/gallery_13.jpg",
    title: "Greenfinity View Apartment",
    category: "image"
  }, {
    id: 17,
    url: "/images/gallery_14.jpg",
    title: "Greenfinity View Apartment",
    category: "image"
  }, {
    id: 18,
    url: "/images/gallery_15.jpg",
    title: "Greenfinity View Apartment",
    category: "image"
  }, {
    id: 19,
    url: "/images/gallery_16.jpg",
    title: "Greenfinity View Apartment",
    category: "image"
  }, {
    id: 20,
    url: "/images/gallery_17.jpg",
    title: "Greenfinity View Apartment",
    category: "image"
  }, {
    id: 21,
    url: "/images/gallery_18.jpg",
    title: "Greenfinity View Apartment",
    category: "image"
  }, {
    id: 22,
    url: "/images/gallery_19.jpg",
    title: "Greenfinity View Apartment",
    category: "image"
  }
];

// export const galleryVideos = [
//   {
//     id: 1,
//     title: "Construction Phase",
//     thumbnail:"/images/Ashish-Construction-09-13-2025_07_43_PM.png",
//     duration: "3:42",
//     url: "https://www.youtube.com/embed/UpdIzsq1G6w?si=SU9z3WPDFPVdchHL"
//   },
// ];

export const galleryVideos = [
  // {
  //   id: 1,
  //   title: "Construction Phase",
  //   thumbnail: "/images/Ashish-Construction-09-13-2025_07_43_PM.png",
  //   duration: "3:42",
  //   url: "https://www.youtube.com/embed/UpdIzsq1G6w?si=SU9z3WPDFPVdchHL", 
  // },
  {
    id: 2,
    title: "Downloaded Phase Video",
    thumbnail: "/images/video_thumbnail.png", // optional thumbnail
    duration: "2:30",
    url: "p_greenfinity.mp4",
  },
  {
    id: 3,
    title: "Another MP4 Video",
    thumbnail: "/images/video_thumbnail2.png",
    duration: "1:50",
    url: "p_ikebena.mp4",
  },
  {
    id: 3,
    title: "Another MP4 Video",
    thumbnail: "/images/video_thumbnail2.png",
    duration: "1:50",
    url: "p_serenety.mp4",
  },
];


export const testimonials = [
  {
    id: 1,
    name: "Dr. Ankita Randhir",
    location: "Nagpur",
    rating: 5,
    text: "Very good and well contructed project.Happy with the interior and furniture of gym and party area.Satisfied with the builders and his staff regarding cooperation",
  },
  {
    id: 2,
    name: "Manoj Sharma",
    location: "Nagpur",
    rating: 5,
    text: "An absolutely phenomenal project with amazing construction quality",

  },
  {
    id: 3,
    name: "Dinesh Badoniya",
    location: "Nagpur",
    rating: 5,
    text: "The construction of the scheme is very good, there is adequate lighting, full care has been taken of sunlight, the outer look and arrangement is very excellent.",

  },

];

export const aboutUsData = {
  title: "About Madhu Prabha Construction",
  shortDescription: "Leading residential construction company with 20 Glorious Years of experience in creating quality construction.",
  fullDescription: ` Madhuprabha Constructions Pvt. Ltd. was started in the year 2005 by the name of Ashish Construction. The business start was modest with the regular clients in Nagpur. Over the period, in last 20 years, now we are the leading company in the construction group. Our projects not only deal in Nagpur but also in and around Central India. The journey of hard work, dedication, and trust of our clients has brought us this long way. We deal in the commercials and housing society. With the experience in designing and building these, our company has higher standards in terms of quality and at the same time, it remains affordable to everyone. We are also very well known for the perfect carvings and core commitment for every project. With this, we believe to have a futuristic approach so that our work completion is on time for every project undertaken. We also commit the designing a housing society and commercial complex for a progressive India and we adhere to our traditional values which make a place better to live in, with positivity and peace. Quality and transparency are our main criteria. Ashish Constructions is known for its quality factor and service. We do firmly believe that a house is made of walls and beams, but a home is built with love and dreams.

Success is a state of mind. Anything you want, you can have! You just need to have dreams; believe that you deserve those dreams, and work hard to acquire them! This is a motivational factor for our company.`,

  experience: "20 Glorious Years",
  projectsCompleted: "25+",
  happyClients: "200+",
  awards: "25+",
  location: "Nagpur, Maharashtra",
  image: "https://madhuprabhaconstructions.in/images/about.jpg"
};

export const contactData = {
  address: "UMA Apartment, Behind Binzani Book Depot, Tilak Road, Mahal, Nagpur-2",
  phone1: "+91 95229 01659",
  phone2: "+91 98224 74211",
  email: "info@madhuprabhaconstructions.in",
  googleMapsUrl: "https://www.google.com/maps/place/UMA+Apartment,+Tilak+Road,+Mahal,+Nagpur",
  workingHours: "Mon - Sat: 9:00 AM - 6:00 PM",
};
export const contactSecondData = {
  address: "Ashish Annex, 302, Plot No J 13 A, Scientific Society,WHC Road, Laxmi Nagar, Nagpur-2",
  phone1: "+91 95229 01659",
  phone2: "+91 98224 74211",
  email: "info@madhuprabhaconstructions.in",
  googleMapsUrl: "https://www.google.com/maps/place/UMA+Apartment,+Tilak+Road,+Mahal,+Nagpur",
  workingHours: "Mon - Sat: 9:00 AM - 6:00 PM",
};